import React from 'react';
import { Datagrid, useListContext } from 'react-admin';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  content: {
    fontSize: 14,
    paddingLeft: 16,
    paddingRight: 16,
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 24,
      paddingRight: 24,
    },
    paddingTop: 16,
    paddingBottom: 16,
  },
}));

interface Props {
  emptyText: string;
  [x: string]: any;
}

const EmptyResultsDatagrid = (props: Props) => {
  const { emptyText, ...rest } = props;
  const classes = useStyles();
  const { ids, loaded } = useListContext(props);

  if (loaded && (!ids || ids.length === 0)) {
    return <div className={classes.content}>{emptyText}</div>;
  }

  return <Datagrid {...rest} />;
};

export default EmptyResultsDatagrid;
